import React from 'react';
import FormInput from 'components/Input/FormInput';

interface IProps {
	changeQuantityMaxLimit: (value: Nullable<number>) => void;
}

export const QuantityMaxLimitInput: React.FC<IProps> = React.memo(({ changeQuantityMaxLimit }) => (
	<FormInput
		testId="QuantityMaxLimitInput"
		name="quantityMaxLimit"
		label="maxLimitOfQuantityLabel"
		min={0}
		precision={0}
		onChangeNumber={changeQuantityMaxLimit}
		type="number"
	/>
));
